import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState({       
    reducer(val) { 
      return {
          user: val.user //只儲存使用者資料   
      }
    }
  })],
  state: {
    user:{
      admin: null,
      logged_in: false,
      user_level: 'USER',
      username: null,
      school_id: null,
      school_name: null,
      school_chi_name: null,
      auth_token: null,
    },
    current:{
      experiment:'',
      equipment_id: '',
      booking_id: null,
      end_at: null,
    },
    snackbar:{
        modal: false,
        message:""
    }
  },
  actions: {
  },
  mutations: {
    updateUserInfo(state, {username, user_level, school_id, school_name, school_chi_name, logged_in, auth_token}){
      state.user.username = username;
      state.user.user_level = user_level;
      state.user.school_id = school_id;
      state.user.school_name = school_name;
      state.user.school_chi_name = school_chi_name;
      state.user.logged_in = logged_in;
      state.user.auth_token = auth_token;
    },
    updateCurrentExperiment(state, experiment){
      state.current.experiment = experiment;
    },
    showSnackBar(state, message) {
      state.snackbar.message = message;
      state.snackbar.modal = true;
    }
    
  },
  getters: {
    current: state => {
      return state.current;
    }
  }
})